'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _createReducer;

var _createReducer2 = require('../createReducer');

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = !!process.env.REACT_APP_SERVER;

function homesRequested(homesState, _ref) {
  var builderId = _ref.builderId;

  return (0, _extends5.default)({}, homesState, (0, _defineProperty3.default)({}, builderId, {
    isFetching: true,
    requestedOnServer: isServer
  }));
}

function homesLoaded(homesState, _ref2) {
  var builderId = _ref2.builderId,
      data = _ref2.data,
      receivedAt = _ref2.receivedAt;

  return (0, _extends5.default)({}, homesState, (0, _defineProperty3.default)({}, builderId, (0, _extends5.default)({}, homesState[builderId], {
    isFetching: false,
    data: data,
    receivedAt: receivedAt
  })));
}

function recentHome(homesState, _ref3) {
  var _id = _ref3._id;

  var recent = [_id].concat(homesState.recent || []).reduce(function (result, item) {
    if (!result.includes(item)) {
      return [].concat((0, _toConsumableArray3.default)(result), [item]);
    }

    return result;
  }, []).slice(0, 5);

  if (!process.env.REACT_APP_SERVER) {
    window.localStorage.setItem('recent_homes', (0, _stringify2.default)(recent));
  }

  return (0, _extends5.default)({}, homesState, {
    recent: recent
  });
}

var reducer = (0, _createReducer3.default)({
  recent: !process.env.REACT_APP_SERVER ? JSON.parse(window.localStorage.getItem('recent_homes') || '[]') : []
}, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, _actions.REQUEST_HOMES, homesRequested), (0, _defineProperty3.default)(_createReducer, _actions.RECEIVE_HOMES, homesLoaded), (0, _defineProperty3.default)(_createReducer, _actions.RECENT_HOME, recentHome), _createReducer));

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Homes/reducer.js
// module id = 957
// module chunks = 0